import TYPES from '../../organisms/actions.types';

export const bodyResize = size => (dispatch) => {
  dispatch({
    type: TYPES.APP_RESIZE,
    size,
  });
};
